import React from 'react'
import configment from '@adc/configment'
import classnames from 'classnames/bind'
import { Grid, PageLayout, DropdownMenuLinks } from '@adc/ui-adc'
import styles from './index.scss'
import { states, counties, cities } from './linkData'
const cx = classnames.bind(styles)

const SeoLinksFooter = () => {
  const topUrls = configment.get('RESI_FE_SEO_TOP_PAGES', [])

  return (
    <div
      data-elm-id='marketing_home_seo_links_in_footer_section'
      className={cx('seo-links-container')}
    >
      <PageLayout>
        <Grid relaxed stackable columns={4}>
          <Grid.Row only='mobile tablet computer'>
            <Grid.Column className='seo-drop-links'>
              <DropdownMenuLinks
                text='Foreclosures By State'
                options={states}
                elmId='state'
              />
            </Grid.Column>
            <Grid.Column className='seo-drop-links'>
              <DropdownMenuLinks
                text='Top Counties'
                options={counties}
                elmId='county'
              />
            </Grid.Column>
            <Grid.Column className='seo-drop-links'>
              <DropdownMenuLinks
                text='Top Cities'
                options={cities}
                elmId='city'
              />
            </Grid.Column>
            <Grid.Column className='seo-drop-links'>
              <DropdownMenuLinks
                text='Top Pages'
                options={topUrls}
                elmId='pages'
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </PageLayout>
    </div>
  )
}

export default SeoLinksFooter
